// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Portal,
  Spacer,
  Text,
} from "@chakra-ui/react";
// Custom components
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import React, { useRef } from "react";
import { Link } from "react-router-dom";
// react icons
import { BsArrowRight } from "react-icons/bs";

interface TesseraUniversityProps {
  backgroundImage: string;
}

const TesseraUniversity: React.FC<TesseraUniversityProps> = ({ backgroundImage }) => {
  const title = "Learn To Trade With Tessera University";
  const description =
    "Access hands-on courses, proven trading strategies, and expert guidance tailored for the Tessera trading community.";
  const overlayRef = useRef<HTMLDivElement>(null);
  return (
    <Card maxHeight='240px' p='1rem'>
      <CardBody
        p='0px'
        w='100%'
        h={{ sm: "200px", lg: "100%" }}
        position='relative'
        borderRadius='15px'
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}>
        <Box
          bg='linear-gradient(360deg, rgba(49, 56, 96, 0.16) 0%, rgba(21, 25, 40, 0.88) 100%)'
          w='100%'
          position='absolute'
          h='inherit'
          borderRadius='inherit'
          zIndex={1}
          ref={overlayRef}></Box>
        <Portal containerRef={overlayRef}>
          <Box position='relative' h='100%' w='100%' display='flex' flexDirection='column'>
            <Flex
              flexDirection='column'
              color='white'
              p='1rem 1.2rem 0.3rem 1.2rem'
              lineHeight='1.6'
              flex='1'
              pb='3.5rem'>
              <Text fontSize='xl' fontWeight='medium' pb='.3rem' color="white" fontFamily="'Urbanist', sans-serif">
                {title}
              </Text>
              <Text fontSize='sm' fontWeight='normal' w={{ lg: "92%" }}>
                {description}
              </Text>
            </Flex>
            <Flex
              position='absolute'
              bottom='0'
              left='0'
              align='center'
              p='1rem 1.2rem'
              zIndex={10}>
              <Link to="/university" style={{ textDecoration: 'none' }}>
                <Button p='0px' variant='no-hover' bg='transparent' display='flex' alignItems='center' _hover={{ cursor: 'pointer' }}>
                  <Text
                    fontSize='sm'
                    color="white"
                    fontWeight='medium'
                    fontFamily="'IBM Plex Sans', sans-serif"
                    textTransform="uppercase"
                    _hover={{ me: "4px" }}
                    transition='all .5s ease'>
                    Read more
                  </Text>
                  <Icon
                    as={BsArrowRight}
                    w='20px'
                    h='20px'
                    fontSize='xl'
                    color="white"
                    transition='all .5s ease'
                    mx='.3rem'
                    cursor='pointer'
                    _hover={{ transform: "translateX(20%)" }}
                  />
                </Button>
              </Link>
            </Flex>
          </Box>
        </Portal>
      </CardBody>
    </Card>
  );
};

export default TesseraUniversity;
